import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * ArrowIcon - An arrow icon used for navigation and direction indicators
 */
export const ArrowIcon = ({ size = 9, color = "black", direction = "right", className = "", style, ...props }) => {
    const rotationMap = {
        right: 0,
        left: 180,
        up: -90,
        down: 90,
    };
    const rotation = rotationMap[direction];
    const transform = rotation !== 0 ? `rotate(${rotation}deg)` : undefined;
    return (_jsx(Icon, { size: size, color: color, viewBox: "0 0 9 17", className: className, style: { transform, transition: "transform 0.2s", ...style }, ...props, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L8.78033 7.71967C9.07322 8.01256 9.07322 8.48744 8.78033 8.78033L1.28033 16.2803C0.987437 16.5732 0.512563 16.5732 0.21967 16.2803C-0.0732233 15.9874 -0.0732233 15.5126 0.21967 15.2197L7.18934 8.25L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z", fill: color }) }));
};
